/**
 * Banner displayed when the user is on a sandbox tenant.
 * Warns that the tenant uses staging credentials and data may be temporary.
 * TODO: Temporarily hidden for all tenants — restore implementation when ready.
 */
export function SandboxBanner() {
  return null;
}
